import {
  Alert,
  Box,
  Button,
  Grid,
  Typography,
  AlertTitle,
} from "@mui/material";
import Header from "../../../components/Header";
import SetupGuide from "../../../components/SetupGuide";
import axios from "axios";
import swal from "sweetalert";
import { useEffect, useState } from "react";
import VerifiedIcon from "@mui/icons-material/Verified";
import CancelIcon from "@mui/icons-material/Cancel";
import CircularProgress from "@mui/material/CircularProgress";

const DomainVerification = ({ domain, domainPointed, handleDomainPointed }) => {
  const [checkStatusClicked, setCheckStatusClicked] = useState(false);

  async function handleCheckStatus() {
    await axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/check-domain-ip-address?domain=${domain}`,
        {
          headers: {
            "content-type": "application/json",
            token: localStorage.getItem("token"),
          },
        }
      )
      .then((response) => {
        if (response.data.ipAddress === process.env.REACT_APP_IP_SERVER) {
          handleDomainPointed(true);
        } else {
          handleDomainPointed(false);
        }
        setCheckStatusClicked(true);
      })
      .catch((error) => {
        handleDomainPointed(false);
        setCheckStatusClicked(true);
        if (error.response.data.invalidDomain) {
          swal({
            title: "Error!",
            text: "Please provide the valid domain name",
            icon: "error",
            button: "OK",
          });
        } else {
          swal({
            title: "Something Went Wrong!",
            icon: "error",
            button: "OK",
          });
        }
      });
  }

  useEffect(() => {
    handleCheckStatus();
  });

  return (
    <Box mt="40px" ml="70px">
      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Header
          title="Domain Verification"
          subtitle="Provide SSL certificates"
        />
        <SetupGuide url={process.env.REACT_APP_GENERAL_SETUP_GUIDE} />
      </Box>
      <Grid mb={3} item md={12} sm={12} xs={12}>
        <Alert severity="info" sx={{ fontFamily: "Poppins" }}>
          Note : Please point your CName to{" "}
          {process.env.REACT_APP_DOMAIN_NAME + " "}(
          {process.env.REACT_APP_IP_SERVER}) on DNS
        </Alert>
      </Grid>
      <Box
        variant="gradient"
        borderRadius="lg"
        shadow="lg"
        opacity={1}
        p={3}
        textAlign="left"
        sx={{
          backgroundColor: "white",
          boxShadow: 2,
        }}
      >
        <Box style={{ display: "flex" }}>
          <Box style={{ flex: "1.45", paddingRight: "25px" }}>
            <Typography
              variant="h5"
              color={"#006A50"}
              marginTop={"15px"}
              fontFamily="Poppins"
            >
              Please point your domain to verify your ownership of the domain
            </Typography>

            <Typography variant="h6" marginTop={"15px"} fontFamily="Poppins">
              <strong> Status:</strong>

              {domainPointed !== null &&
                (domainPointed ? (
                  <>
                    {"  "}
                    <VerifiedIcon
                      style={{ color: "rgb(0, 104, 74)", marginBottom: "-5px" }}
                    />
                    Your Domain is successfully pointed to&nbsp;
                    {process.env.REACT_APP_DOMAIN_NAME} (
                    {process.env.REACT_APP_IP_SERVER}) on DNS
                  </>
                ) : (
                  <>
                    {"  "}
                    <CancelIcon
                      style={{ color: "tomato", marginBottom: "-5px" }}
                    />{" "}
                    Please point your domain to&nbsp;
                    {process.env.REACT_APP_DOMAIN_NAME} (
                    {process.env.REACT_APP_IP_SERVER}) on DNS
                  </>
                ))}
            </Typography>

            <Button
              className="custom-color-button"
              sx={{ marginTop: "16px" }}
              variant="contained"
              onClick={() => {
                setCheckStatusClicked(false);
                handleCheckStatus();
              }}
              disabled={domainPointed}
            >
              Check status
            </Button>
            {checkStatusClicked ? (
              <Grid item xs={12} mt={4}>
                {domainPointed ? (
                  <Alert severity="success">
                    <AlertTitle>Success</AlertTitle>
                    Your Domain is successfully pointed
                  </Alert>
                ) : (
                  <Alert severity="warning">
                    <AlertTitle>Warning</AlertTitle>
                    Your Domain is not pointed
                  </Alert>
                )}
              </Grid>
            ) : (
              <Grid
                item
                xs={12}
                mt={4}
                style={{ display: "flex", alignItems: "center" }}
              >
                <CircularProgress
                  style={{ margin: "auto", color: "rgb(7,85,49) " }}
                />
              </Grid>
            )}
          </Box>
          <Box id="guide-container" style={{ flex: "1" }}>
            <h2 className="guide-title">How to point your Domain?</h2>
            <ol className="guide-list">
              <li className="guide-item">
                <strong>Locate DNS Settings:</strong> Navigate to the DNS
                management section in your domain registrar or hosting
                provider's dashboard
              </li>
              <li className="guide-item">
                <strong>Edit A Record:</strong> Locate your domain's A record
                settings.
              </li>
              <li className="guide-item">
                <strong>Update IP Address:</strong> Modify the IP address
                associated with the A record to{""}
                {process.env.REACT_APP_IP_SERVER}.
              </li>
            </ol>
            <p className="note">
              <strong>Note:</strong> DNS changes may take some time to
              propagate, ranging from few minutes to hours.
            </p>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DomainVerification;
